import Footer from "./Footer";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Calendar,
  Clock,
  Users,
  Heart,
  Dumbbell,
  ShieldCheck,
  Award,
  ArrowRight,
  Star,
} from "lucide-react";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import beforeAfterImage from "../asset/RevibeLanding/beforeAfterImage.png";
import meraIndiaImage from "../asset/RevibeLanding/meraIndiaImage.png";
import ScrollButton from "../components/ScrollToTop"; // adjust path if needed

import image1 from "../asset/testinomial/Artboard1.webp";
import image2 from "../asset/testinomial/Artboard2.webp";
import image3 from "../asset/testinomial/Artboard3.webp";
import image4 from "../asset/testinomial/Artboard4.webp";
import image5 from "../asset/testinomial/Artboard5.webp";
const testimonials = [
  { id: 1, img: image1 },
  { id: 2, img: image2 },
  { id: 3, img: image3 },
  { id: 4, img: image4 },
  { id: 5, img: image5 },
];
// Common Register Button Component
const RegisterButton = ({ className = "", children }) => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate("/revibe-registration-form");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={handleRegisterClick}
      className={`bg-[#E80003] hover:bg-[#d31111] font-bold text-white rounded-xl px-8 py-4 text-sm md:text-base uppercase tracking-wide shadow-lg hover:shadow-xl transition-all duration-300 animate-blink ${className}`}
      style={{ animation: "blink 1.5s infinite" }}
    >
      {children || "Register Your Free Seat Now"}
    </button>
  );
};

const GuaranteeBox = ({ text }) => (
  <div
    className="bg-gradient-to-r from-yellow-100 to-amber-100 border-4 border-yellow-400 rounded-3xl py-5 text-center animate-blink"
    style={{
      animation: "blink 1.5s infinite",
    }}
  >
    <p className="text-sm md:text-xl font-extrabold uppercase text-orange-900">
      {text}
    </p>
  </div>
);

const LandingPage = () => {
  const [workshopData, setWorkshopData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWorkshopData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/revibeWorkshop`,
        );
        if (response?.data?.success && response?.data?.data?.length > 0) {
          setWorkshopData(response.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching workshop data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWorkshopData();
  }, []);

  const infoBoxes = [
    {
      icon: <FaCalendarAlt style={{ fontSize: 26, color: "#1B4332" }} />,
      text: workshopData?.date || "9 April 2026",
    },
    {
      icon: <FaClock style={{ fontSize: 26, color: "#1B4332" }} />,
      text: workshopData?.time || "08:00 P.M - 9:30 P.M",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 font-sans overflow-x-hidden">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-gradient-to-br from-green-900 via-green-800 to-emerald-700 text-white">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-4 sm:px-6 py-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl  font-bold mb-6 leading-tight">
              Whether your goal is{" "}
              <span className="text-yellow-300">10kgs</span> or{" "}
              <span className="text-yellow-300">60kgs</span> weightloss —
            </h1>

            <h1 className="text-3xl mb-6 uppercase font-extrabold leading-tight">
              We give{" "}
              <span className="whitespace-normal">
                assured, sustainable, weightloss
              </span>{" "}
              & 100% Transformation.
            </h1>

            <p className="text-2xl  mb-6  text-orange-300 font-medium ">
              "Best time to get Fit was 15 years ago, 2nd best time is now."
            </p>

         

            <div className="bg-white/10 rounded-2xl px-4 py-2 inline-flex items-center justify-center gap-2 sm:gap-3 mb-6 ">
              <span className="text-yellow-300 font-semibold text-xl ">
                FREE Online Masterclass
              </span>
            </div>

            {/* Date and Time Boxes - Side by side on mobile */}
            <div className="flex flex-row justify-center gap-3 sm:gap-4 mb-6 sm:mb-10">
              {infoBoxes.map((box, idx) => (
                <div
                  key={idx}
                  className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-100 to-amber-100 rounded-xl p-3 shadow-sm min-w-[140px]"
                >
                  <div className="flex-shrink-0 text-orange-600">
                    {box.icon}
                  </div>
                  <span className="text-green-900 font-bold text-xs sm:text-sm leading-tight">
                    {box.text}
                  </span>
                </div>
              ))}
            </div>

            {/* Section 4 - Guarantee */}
            <section className="pb-8">
              <GuaranteeBox text="NO FAKE HYPE - 100% TRANSFORMATION or 100% Money Back Guarantee" />
            </section>

            <RegisterButton className="w-full text-xl md:text-2xl py-4" />
          </div>
        </div>
      </div>

      {/* Before After Section */}
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-2xl bg-gray-100">
            <img
              src={beforeAfterImage}
              alt="Before After Transformation"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-white py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6">
          {/* Heading */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12">
            WHY OUR WEIGHT LOSS PROGRAM IS BEST FOR YOU!!
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 max-w-6xl mx-auto">
            {[
              {
                icon: <Users className="w-7 h-7 sm:w-8 sm:h-8" />,
                title: "5,000+ Clients",
                desc: "India's most affordable — Assured, Sustainable Weight-loss Program",
                bg: "bg-green-100",
              },
              {
                icon: <Heart className="w-7 h-7 sm:w-8 sm:h-8" />,
                title: "Dedicated Team",
                desc: "Daily Hand Holding",
                bg: "bg-pink-100",
              },
              {
                icon: <Dumbbell className="w-7 h-7 sm:w-8 sm:h-8" />,
                title: "No Gym, No Shakes",
                desc: "No Crash Diets",
                bg: "bg-blue-100",
              },
              {
                icon: <Award className="w-7 h-7 sm:w-8 sm:h-8" />,
                title: "1,600+ Transformations",
                desc: "Success stories that inspire",
                bg: "bg-yellow-100",
              },
            ].map((feature, idx) => (
              <div
                key={idx}
                className={`${feature.bg} p-5  rounded-2xl text-center hover:shadow-xl transition-all hover:-translate-y-1`}
              >
                <div className="text-green-600 flex justify-center mb-3 ">
                  {feature.icon}
                </div>
                <h3 className="font-bold text-lg  mb-1 ">{feature.title}</h3>
                <p className="text-gray-600 text-base ">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Combined Guarantee + Brand Section */}
      <div className="bg-gradient-to-r from-yellow-50 to-orange-50 py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <img
                  src={meraIndiaImage}
                  alt="Mera India Builds Fitness"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="w-full px-4 py-2 mt-4 mb-2 text-center flex flex-col justify-center">
                <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-yellow-400 rounded-full mb-4 sm:mb-6 mx-auto">
                  <ShieldCheck className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-gray-900" />
                </div>

           

                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 text-gray-800">
                  NO FAKE HYPE
                </h2>

                <p className="text-lg sm:text-xl md:text-2xl font-bold text-green-700 mb-4 sm:mb-6">
                  100% TRANSFORMATION or 100% MONEY BACK GUARANTEE
                </p>

                <div className="flex justify-center gap-1 sm:gap-2">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-500 fill-current"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            <div className="bg-white py-6 px-4 rounded-2xl shadow-md">
        {/* Date and Time Boxes - Side by side on mobile */}
        <div className="flex flex-row justify-center gap-3 sm:gap-4 mb-6 sm:mb-10">
          {infoBoxes.map((box, idx) => (
            <div
              key={idx}
              className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-100 to-amber-100 rounded-xl p-3 shadow-sm min-w-[140px]"
            >
              <div className="flex-shrink-0 text-orange-600">{box.icon}</div>
              <span className="text-green-900 font-bold text-xs sm:text-sm leading-tight">
                {box.text}
              </span>
            </div>
          ))}
        </div>

        <RegisterButton className="w-full text-xl md:text-2xl py-4" />
      </div>
      {/* Section 11 - Testimonials */}
      <section className="bg-green-900  p-4 md:p-8 text-white ">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-2xl md:text-5xl font-black">Testimonials</h2>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3 md:gap-5">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden shadow-lg bg-black"
            >
              <img
                src={item.img}
                alt={`Testimonial ${item.id}`}
                className="w-full aspect-[3/4] object-cover transition duration-500"
              />
            </div>
          ))}
        </div>
      </section>
        <div className="bg-white py-6 px-4 rounded-2xl shadow-md">
          {/* Date and Time Boxes - Side by side on mobile */}
          <div className="flex flex-row justify-center gap-3 sm:gap-4 mb-6 sm:mb-10">
            {infoBoxes.map((box, idx) => (
              <div
                key={idx}
                className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-100 to-amber-100 rounded-xl p-3 shadow-sm min-w-[140px]"
              >
                <div className="flex-shrink-0 text-orange-600">{box.icon}</div>
                <span className="text-green-900 font-bold text-xs sm:text-sm leading-tight">
                  {box.text}
                </span>
              </div>
            ))}
          </div>

          <RegisterButton className="w-full text-xl md:text-2xl py-4" />
        </div>

      {/* Footer */}
      <Footer />

      {/* ✅ Scroll To Top Button */}
      <ScrollButton />
    </div>
  );
};

export default LandingPage;
